"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
var pricing_1 = require("../../../api/pricing");
var PricingNewLicensing = function (props) {
    var buttonLabel = props.buttonLabel, className = props.className;
    var _a = react_1.useState(false), modal = _a[0], setModal = _a[1];
    var _b = react_1.useState(''), name = _b[0], setName = _b[1];
    var _c = react_1.useState(''), description = _c[0], setDescription = _c[1];
    var _d = react_1.useState(''), costPrice = _d[0], setCostPrice = _d[1];
    var _e = react_1.useState(''), sellingPrice = _e[0], setSellingPrice = _e[1];
    var _f = react_1.useState(''), frequency = _f[0], setFrequency = _f[1];
    var submitForm = function (e) {
        var obj = {
            name: name,
            description: description,
            costPrice: costPrice,
            sellingPrice: sellingPrice,
            frequency: frequency
        };
        console.log(obj);
        pricing_1.createLicense(obj).then(function (res) {
            props.modalCallback(res);
            toggle();
        });
    };
    var toggle = function () { return setModal(!modal); };
    return (React.createElement("div", { className: "NewLicenseContainer" },
        React.createElement(reactstrap_1.Button, { className: "NewLicenseButton", color: "", onClick: toggle },
            React.createElement("a", { className: "padding-default NewLicenseText" }, "+ New Licensing")),
        React.createElement(reactstrap_1.Modal, { isOpen: modal, toggle: toggle, className: className, size: "lg", centered: true },
            React.createElement(reactstrap_1.ModalHeader, { toggle: toggle }, "New Licensing"),
            React.createElement(reactstrap_1.ModalBody, null,
                React.createElement(reactstrap_1.Form, null,
                    React.createElement(reactstrap_1.Row, { form: true },
                        React.createElement(reactstrap_1.Col, { md: 6 },
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "Name" }, "Name"),
                                React.createElement(reactstrap_1.Input, { type: "text", name: "name", id: "name", placeholder: "Name", onChange: function (e) { return setName(e.target.value); } })),
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "SellingPrice" }, "Selling Price*"),
                                React.createElement(reactstrap_1.Input, { type: "text", name: "SellingPrice", id: "SellingPrice", placeholder: "Enter selling price", onChange: function (e) { return setSellingPrice(e.target.value); } }))),
                        React.createElement(reactstrap_1.Col, { md: 6 },
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "CostPrice" }, "Cost Price*"),
                                React.createElement(reactstrap_1.Input, { type: "text", name: "CostPrice", id: "CostPrice", placeholder: "Enter cost price", onChange: function (e) { return setCostPrice(e.target.value); } })),
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "MonthlyAnually" }, "MonthlyAnually*"),
                                React.createElement(reactstrap_1.Input, { type: "select", name: "MonthlyAnually", id: "MonthlyAnually", onChange: function (e) { return setFrequency(e.target.value); } },
                                    React.createElement("option", { value: "", disabled: true, selected: true, hidden: true }, "Please select"),
                                    React.createElement("option", { value: "Monthly" }, "Monthly"),
                                    React.createElement("option", { value: "Yearly" }, "Annually"))))),
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, { md: 12 },
                            React.createElement(reactstrap_1.FormGroup, null,
                                React.createElement(reactstrap_1.Label, { for: "Description" }, "Description*"),
                                React.createElement(reactstrap_1.Input, { type: "textarea", name: "Description", id: "Description", placeholder: "Enter Description", onChange: function (e) { return setDescription(e.target.value); } })))))),
            React.createElement(reactstrap_1.ModalFooter, null,
                React.createElement(reactstrap_1.Button, { color: "primary", onClick: toggle }, "Cancel"),
                ' ',
                React.createElement(reactstrap_1.Button, { color: "secondary", onClick: submitForm }, "Confirm")))));
};
exports.default = PricingNewLicensing;
//# sourceMappingURL=PricingNewLicensing.js.map